<template>
    <b-modal ref="copied" hide-footer :title="$ml.get('copiedM')">
        <b-form @submit.prevent="onSubmit()">
            <b-card no-body border-variant="msstream" class="marginal" style="margin-top:0px; margin-bottom:20px">
                <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h6>{{$ml.get('copied')}}</h6>
                </b-card-header>

                <b-card-body>

                    <p>{{$ml.get('selectedtextcopied')}}</p>
                    <b-row class="justify-content-around">
                    <b-btn size="sm" class="col-md-3 col-5" variant="msstreamblue" block @click="cleanMyTimeout();$refs.copied.hide()">Ok</b-btn>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-form>
    </b-modal>
</template>

<script>
    export default {
        data: function() {
            return {
                timeout: null,
            }
        },
        methods: {
            cleanMyTimeout() {
            try {
                clearTimeout(this.timeout);
            } catch(err) {}
            },
            copyToClipboard(text) {
                this.cleanMyTimeout();
                this.$copyText(text);
                this.$refs.copied.show();
                this.timeout = setTimeout(this.$refs.copied.hide, 2.5 * 1000, 'copied');
            },
        }
    }
</script>